import accountDetails from './accountDetails/accountDetailsSlice';
import detailedHours from './detailedHours/detailedHoursSlice';
import mapsApiKey from './mapsApiKey/mapsApiKeySlice';

const root = {
	accountDetails,
	detailedHours,
	mapsApiKey
};

export default root;
